export default [
    {path: '/sp-better/splist/:p?', component: () => import('./views/patch/index.vue')},
    {path: '/sp-better/extensions/:p?', component: () => import('./views/extensions/index.vue')},
    {path: '/sp-better/product-splist/:p?', component: () => import('./views/product/index.vue')},
    {path: '/sp-better/feedback/:p?', component: () => import('./views/feedback/index.vue')},
    {path: '/sp-better/col-dev-info/:p?', component: () => import('./views/device/index.vue')},
    {path: '/sp-better/check-sp/:p?', component: () => import('./views/check/index.vue')},
    {path: '/*', redirect: '/sp-better/splist/:p?'}
]
